import { User ,SessionUser} from './user';

export class Login {
    email: string;
    password: string;
   
}

export class LoginData {
    user: SessionUser;
    token: Token;
    plandata:string;
    per:number;
    
}

// export class User {
//   [x: string]: any;
//     user_reg_id: number;
//     firstName: string;
//     lastName: string;
//     emailAddress: string;
//     mobileNumber: string;
//     password: string;
//     dob: string;
//     education: string;
//     gender: string;
//     status: string;
//     planID: number;
//     enabled: boolean;
//     role: string;
//     address: string;
//     emailData: string;
//     approvedEmail: string;
//     planStatus:string;

// }

export class Token {
    token: string;
}
